import { getReactAppConfig } from "shared/functions";

export const routes = {
  // auth
  auth: "/auth",

  login: "/login",
  register: "/register",
  forgotPassword: "/forgot-password",
  resetPassword: "/reset-password",
  google: "auth/google/callback",
  facebook: "auth/facebook/callback",

  // cabinet
  home: "/home",
  invoices: "/invoices",
  accounts: "/accounts",

  createInvoice: "/invoices/create",

  integrations: "/integrations",
  apiToken: "/api-token",

  profile: "/profile",
  subscription: "/subscription",

  settings: "/settings",

  support: "/support",
  faq: "/faq",

  root: "/",

  // Website
  publicOffer: "/public-offer",
  termsOfService: "/terms-of-service",
  ibanOplata: "/iban-oplata",
  ibanQr: "/iban-qr",
  dynamicInvoice: "/i",

  sip: "/sip",
  autoService: "/auto-service",
  onlineSales: "/online-sales",
  hotels: "/hotels",
  beauty: "/beauty",

  // Other
  subscriptions: "/subscriptions",
  error: "/error",
};

const config = getReactAppConfig();

export const apiURL = config.REACT_APP_API_URL;
export const apiSwaggerURL = apiURL + "/swagger";
